import {Component, Input, OnInit} from '@angular/core';
import {BookingEditorCommercialModel} from '../../../services/booking-editor/booking-editor.model';
import {BookingEditorService} from '../../../services/booking-editor/booking-editor.service';
import {MediumDTO} from '../../../services/api/api';

@Component({
  selector: 'sb-event-tooltip',
  templateUrl: './sb-event-tooltip.component.html',
  styleUrls: ['./sb-event-tooltip.component.scss'],
  standalone: false,
})
export class SbEventTooltipComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  _commercialId: string;
  @Input() time;

  @Input() set commercialId(value: string) {
    this._commercialId = value;
  }

  previews: MediumDTO[];
  commercialEvent: BookingEditorCommercialModel | any;

  constructor(public bookingEditor: BookingEditorService) {}

  ngOnInit(): void {
    this.commercialEvent = this.bookingEditor.eventStore.getById(this._commercialId);
    this.previews = this.commercialEvent?.data?.commercial?.preview;
  }

  showPreview() {
    return true;
  }

  buildPreviewMedias() {
    this.previews = [];
    for (const req of this.commercialEvent?.data?.commercial?.requirements) {
      this.previews.push(req.previewMedia[0]);
    }
  }
}
